/* Native Shopify navigation and POST forms work without JavaScript. */
(() => {
  const bind = () => {
    const menus = [...document.querySelectorAll('.hbn-header details')];
    menus.forEach(menu => {
      if (menu.dataset.hbnBound) return;
      menu.dataset.hbnBound = 'true';
      menu.addEventListener('toggle', () => {
        if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
      });
    });
  };
  bind();
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.hbn-header details[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.hbn-header details[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
})();
